export default __webpack_public_path__ + "static/media/highFive.7eb58c93.svg";